"use client";

import { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/language-context';

interface CopyButtonProps {
  text: string;
  className?: string;
  size?: "sm" | "default";
  variant?: "outline" | "ghost";
}

export function CopyButton({ text, className = "", size = "sm", variant = "outline" }: CopyButtonProps) {
  const [isCopied, setIsCopied] = useState(false);
  const { t } = useLanguage();

  const handleCopy = async () => {
    await navigator.clipboard.writeText(text);
    setIsCopied(true);

    // Reset after 3 seconds
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  const label = isCopied ? t('common.copied') : t('common.copy');

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleCopy}
      className={`!p-1.5 transition-all duration-400 ${className}`}
      aria-label={label}
      title={label}
    >
      <div className="transition-all duration-400">
        {isCopied ? (
          <Check className="w-4 h-4" strokeWidth={1.5} />
        ) : (
          <Copy className="w-4 h-4" strokeWidth={1.5} />
        )}
      </div>
    </Button>
  );
}
